import checkRequiredBoolean from './checkRequiredBoolean';

const errorString = 'Vous devez cocher ce champ.';

const checkRequiredTrue = (field) => checkRequiredBoolean(field, true, errorString);

export default checkRequiredTrue;
